import {useEffect, useRef, useState} from "react";

export const useClickOutside = (customOpen: boolean = false, onClose?: () => void) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isOpen || customOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, customOpen]);

    function handleClickOutside(event: MouseEvent): void {
        if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
            if (onClose) onClose()

            if (!onClose) close()
        }
    }

    function open() {
        setIsOpen(true)
    }

    function close() {
        setIsOpen(false)
    }

    return {containerRef, isOpen, open, close}
}